import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Flame, Eye, Brush, SprayCan, Shirt } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function AdditionalServices() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: <Droplets className="w-8 h-8" data-id="element-22" />,
    title: t('additionalServices.s1Title'),
    description: t('additionalServices.s1Desc')
  }, {
    icon: <Flame className="w-8 h-8" data-id="element-23" />,
    title: t('additionalServices.s2Title'),
    description: t('additionalServices.s2Desc')
  }, {
    icon: <Eye className="w-8 h-8" data-id="element-24" />,
    title: t('additionalServices.s3Title'),
    description: t('additionalServices.s3Desc')
  }, {
    icon: <Brush className="w-8 h-8" data-id="element-25" />,
    title: t('additionalServices.s4Title'),
    description: t('additionalServices.s4Desc')
  }, {
    icon: <SprayCan className="w-8 h-8" data-id="element-26" />,
    title: t('additionalServices.s5Title'),
    description: t('additionalServices.s5Desc')
  }, {
    icon: <Shirt className="w-8 h-8" data-id="element-27" />,
    title: t('additionalServices.s6Title'),
    description: t('additionalServices.s6Desc')
  }];
  return <Section className="bg-barber-dark border-y border-barber-lightGray" data-id="element-28">
      <div className="text-center mb-16" data-id="element-29">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-barber-text uppercase mb-4" data-id="element-30">
          {t('additionalServices.heading1')}{' '}
          <span className="text-barber-gold" data-id="element-31">
            {t('additionalServices.heading2')}
          </span>
        </h2>
        <p className="text-barber-muted text-lg md:text-xl mt-4" data-id="element-32">
          {t('additionalServices.subtitle')}
        </p>
        <div className="w-16 h-1 bg-barber-gold mx-auto mt-4" data-id="element-33"></div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-34">
        {services.map((service, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-barber-black border border-barber-lightGray p-8 rounded-sm hover:border-barber-gold/50 transition-colors group" data-id="element-35">
            <div className="text-barber-gold mb-6 bg-barber-gold/10 w-16 h-16 flex items-center justify-center rounded-full group-hover:scale-110 transition-transform" data-id="element-36">
              {service.icon}
            </div>
            <h3 className="font-heading text-2xl font-bold text-barber-text uppercase tracking-wide mb-3" data-id="element-37">
              {service.title}
            </h3>
            <p className="text-barber-muted text-lg" data-id="element-38">{service.description}</p>
          </motion.div>)}
      </div>
    </Section>;
}